import WebStorage, { storageTypes } from '@/Utils/WebStorage';
// since this functionality was originaly designed for issues, in order to not reveal previously hidden issues,
// we are using a ...IssuesStorage name for both issues and recommendations
const performanceMarketingHiddenCampaignIssuesStorage = new WebStorage('store.web.performanceMarketing.HiddenCampaignIssues', storageTypes.localStorage);

export function addHiddenTip(tip) {
    let storage = performanceMarketingHiddenCampaignIssuesStorage.get();
    if (!storage) {
        storage = { issues: [] };
    }

    if (!storage.issues.find(t => t.hash === tip.hash)) {
        storage.issues.push(tip);
    }
    performanceMarketingHiddenCampaignIssuesStorage.set(storage);
}

export function buildVisibleTipsList(tips) {
    const hiddenTips = performanceMarketingHiddenCampaignIssuesStorage.get()?.issues ?? [];
    return tips.filter(t => !hiddenTips.find(ht => ht.hash === t.hash));
}